import gql from "graphql-tag";

const PersonalAssessmentProps = gql`
    fragment PersonalAssessmentProps on PersonalAssessment {
        id
        health_state
        author {
            id
            surname
            first_name
            middle_name
            designation {
                id
                name
            }
        }
        questions {
            key
            value
        }
        created_at
    }
`;

export const NEW_PERSONAL_ASSESSMENT = gql`
    mutation RecordPersonalAssessment($model: PersonalAssessmentInput!) {
        RecordPersonalAssessment(model: $model) {
            message
            doc {
                ...PersonalAssessmentProps
            }
        }
    }
    ${PersonalAssessmentProps}
`;

export const GET_PERSONAL_ASSESSMENT = gql`
    query GetPersonalAssessment($patient: ID!) {
        GetPatientPersonalAssessments(patient: $patient) {
            docs {
                ...PersonalAssessmentProps
            }
        }
    }
    ${PersonalAssessmentProps}
`;
